import { api } from "./NetworkBase";

export async function GetBatches() {
	return await api.get("ScannerApp/batch").json();
}

export async function CreateBatch(batch) {
	let response = await api
		.post("ScannerApp/batch", {
			json: batch,
		})
		.json();

	return response;
}

export async function UpdateBatch(batch) {
	let response = await api
		.put("ScannerApp/batch/" + batch.id, {
			json: batch,
		})
		.json();

	return response;
}

/**
 *
 * @param {number} id The id of the batch to delete
 * @returns
 */
export async function DeleteBatch(id) {
	let response = await api.delete("ScannerApp/batch/" + id).json();

	return response;
}

/**
 * Review results.
 * @param {[int]} sampleIds The array of sampleIds to submit to the database result
 * @param {string} reviewComment The comment of the review
 */
 export async function ReviewResults(sampleIds, reviewComment) {
	let sampleIdList = sampleIds;
	if (!Array.isArray(sampleIds)) sampleIdList = [sampleIds];

	let data = { samples: sampleIdList, reviewComment }

	let response = await api.post("scannerapp/samplesreviewed", { json: data });

	return response;
}

/**
 * Submit the recorded batch results
 * @param {Batch} batch The batch to submit, including the BatchResults
 * @returns
 */
export async function SubmitBatchResults(batch) {
	let response = await api.post("ScannerApp/batchresultstemp", {
		json: batch,
	});

	return response.status;
}

export async function GetTempBatches(pageNumber, pageSize,location,batch,switchChecked) {
	let response = await api.get(`scannerapp/batchresultstemp?pageNumber=${pageNumber}&pageSize=${pageSize}&location=${location}&batchType=${batch}&switchChecked=${switchChecked}`).json();
	return response;
  }
  
  
  export async function GetTempBatchesForTable(switchChecked) {
	let response = await api.get(`scannerapp/batch-manager/batchresultstemp?switchChecked=${switchChecked}`).json();
	return response;
  }


  export async function SearchBatch(pageNumber, startDate = "", endDate = "", searchText = "", pageSize = 5, location = "", batchType = "") {
	try {
		const response = await api.get(
			`scannerapp/batch-manager/search-batches?pageNumber=${pageNumber}&startDate=${startDate}&endDate=${endDate}&searchText=${searchText}&pageSize=${pageSize}&location=${location}&batchType=${batchType}`
		).json();
		return response;
	} catch (error) {
		throw error;
	}
}


/**
 * Commit the stored results for the give sampleIds to the "VLP" result
 * @param {[string]} sampleIds The array of sampleIds to submit to the database result
 */
export async function SubmitResults(sampleIds) {
	let data = sampleIds;
	if (!Array.isArray(sampleIds)) data = [sampleIds];
	let response = await api.post("scannerapp/batchresultsids", { json: data });

	return response;
}

/**
 *
 * @param {Sample} Sample The BatchSample that is being updated
 * @returns
 */
export async function SaveSample(Sample) {
	let response = await api.put("scannerapp/batchsample", { json: Sample });

	return response;
}
//batch/{batchId}/edit-history
export async function SaveBatchEditHistory(data) {
	let response = await api.put("scannerapp/batch/"+data.id+"/edit-history", { json: data });

	return response;
}
export async function UpdateBatchInfo(Sample,Id) {	
	let response = await api.put("scannerapp/batchsample/" + Id, { json: Sample });

	return response;
}

export async function AddSamplesToBatch(Sample,Id) {	
	let response = await api.post("scannerapp/batchsample/" + Id, { json: Sample });

	return response;
}
/**
 *
 * @param {number} sampleId The ID of the sample to delete
 * @returns
 */
export async function DeleteSample(sampleId) {
	let response = await api.delete("scannerapp/batchsample/" + sampleId);

	return response;
}

export async function DeleteSamples(sampleIds) {
	let response = await api.delete("scannerapp/batchsamples", { json: sampleIds });

	return response;
}
